export default __webpack_public_path__ + "static/media/logo.f76cb938.svg";